var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "540.000000pt",
    height: "480.000000pt",
    viewBox: "0 0 540.000000 480.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.15, written by Peter Selinger 2001-2017\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,480.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1780 4189 c-625 -21 -979 -55 -1134 -109 -180 -62 -327 -213 -390 -402 -113 -337 -153 -1375 -81 -2103 48 -476 118 -642 331 -784 156 -105 356 -137 1064 -173 348 -18 1912 -18 2260 0 510 26 771 54 911 98 202 64 362 234 418 444 64 240 101 695 101 1241 0 581 -44 1062 -116 1277 -58 173 -179 309 -340 383 -150 69 -484 104 -1229 129 -330 11 -1458 11 -1795 -1z m1448 -1637 c150 -85 271 -156 270 -157 -7 -7 -1309 -745 -1313 -745 -3 0 -5 337 -5 749 l0 749 388 -220 c213 -121 510 -290 660 -376z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeWhite);
export default __webpack_public_path__ + "static/media/youtube-white.73692b39fd667fdeeeac43ad8ea14c02.svg";
export { ForwardRef as ReactComponent };